/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Action_FailedInputs */

const vi_shop_account_action_failed = /** @type {(inputs: Shop_Account_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thực hiện được. Thử lại sau.`)
};

/**

* @param {Shop_Account_Action_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_action_failed = /** @type {((inputs?: Shop_Account_Action_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Action_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_action_failed(inputs)
});